import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/grid/dependency-row.scss';

Component('tr-grid-dependency-row', {
  mixins: [eventListenerMixin],

  properties: {
    guid: {
      type: String,
    },

    detailUrl: String,

    completed: {
      type: Boolean,
      default: false,
    },

    running: {
      type: Boolean,
      default: false,
    },

    editing: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-menu:opened': () => { this.editing = true; },
      'tr-menu:closed': () => { this.editing = false; },
    });
  },

  handleClick({ target }) {
    if (this.guid && !closest(target, '.actions-menu', this)) {
      this.namespacedTrigger('click', { bubbles: true });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
